module.exports = __webpack_public_path__ + "images/bb691701e6cf982fceac681a76aa6ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/marina_mobile.jpg
// module id = 154
// module chunks = 24